





























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';
import {
  IQueryFailure,
  describeFailure,
  failureSummary,
  logQueryFailure,
  logQueryResult,
} from '@/utils/queryLog.ts';

interface IRanking {
  name: string;
  score: number;
  homeCenterName: string | null;
}

const RANKINGS_QUERY = gql`
  query LeaderboardRankings($leaderboardId: ID!) {
    leaderboardRankings(leaderboardId: $leaderboardId) {
      name
      score
      homeCenterName
    }
  }
`;

@Component({
  components: { Loading },
})
export default class LeaderboardRankings extends Vue {
  @Prop({ required: true, type: String })
  public leaderboardId!: string;

  @Prop({ default: 'Score', type: String })
  public scoreLabel!: string;

  public loading = true;
  public rankings: IRanking[] = [];
  public failure: IQueryFailure | null = null;

  // Counts loads so a response for a board the user has left is ignored.
  private request = 0;

  get failureDetail(): string {
    return this.failure ? failureSummary(this.failure) : '';
  }

  public created() {
    this.load();
  }

  @Watch('leaderboardId')
  public onLeaderboardChanged() {
    this.load();
  }

  private async load() {
    const request = ++this.request;
    const startedAt = Date.now();
    const context = { leaderboardId: this.leaderboardId };
    this.loading = true;
    this.failure = null;

    try {
      // $apollo.query exists at runtime but is missing from this vue-apollo version's types.
      const result = await (this.$apollo as any).query({
        query: RANKINGS_QUERY,
        variables: context,
      });
      if (request !== this.request) {
        return;
      }
      this.rankings = (result.data && result.data.leaderboardRankings) || [];
      logQueryResult('leaderboardRankings', context, this.rankings.length, startedAt);
    } catch (error) {
      if (request !== this.request) {
        return;
      }
      this.rankings = [];
      this.failure = describeFailure(error, startedAt);
      logQueryFailure('leaderboardRankings', context, this.failure);
    }
    this.loading = false;
  }
}
